import { buildSubscriptionPanel } from "../subscriptionPanel";

export const aiCreateMarkup = String.raw`<!-- ====== AI CREATE VIEW ====== -->
    <div class="view" id="view-ai-create">
      <!-- GATED: shown to Free/Lite users (hidden until hydrator resolves auth) -->
      <div id="aiCreateGate" style="display:none;">
        <div class="ai-create-gate">
          <div class="gate-icon" aria-hidden="true">
            <svg class="course-structure-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <path d="M7 5h9.5A2.5 2.5 0 0 1 19 7.5V19H8a3 3 0 0 1-3-3V7a2 2 0 0 1 2-2Z"></path>
              <path d="M8 19a3 3 0 0 1 3-3h8"></path>
              <path d="M9 9h6"></path>
              <path d="M9 12h4"></path>
              <path d="M15.5 11.5 18 14l-2.5 2.5"></path>
            </svg>
          </div>
          <h2>Generate a private course for the topic you actually need.</h2>
          <p class="ai-gate-subtitle">Describe a technical or business problem — AI generates a private course with chapters, source signals, and read/listen/watch modes. Available on Pro &amp; Max.</p>
          <!-- Social proof for AI Create gate -->
          <div style="display:flex;align-items:center;justify-content:center;gap:16px;margin-bottom:32px;font-size:13px;color:var(--fg-tertiary);">
            <span style="display:inline-flex;align-items:center;gap:5px;"><strong data-bind="siteSettings.socialProofPrivateTopics" style="color:var(--fg);">—</strong> private topics created</span>
            <span style="color:var(--border);">|</span>
            <span style="display:inline-flex;align-items:center;gap:5px;"><strong data-bind="siteSettings.socialProofCompletionRate" style="color:var(--fg);">—</strong> completion rate</span>
          </div>

			${buildSubscriptionPanel({ prefix: 'gate', mode: 'showPaywall' })}
        </div>
      </div>

      <!-- Public page structure; authenticated course rows hydrate below. -->
      <div id="aiCreateUnlocked">
        <div class="ai-create-header">
          <div>
            <h1 class="heading-1 mb-8">AI Create</h1>
          </div>
        </div>

        <div class="ai-quota-badge" aria-label="AI Credits" title="AI Credits">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12 14 4-4"></path><path d="M3.34 19a10 10 0 1 1 17.32 0"></path></svg>
          <span id="aiQuotaUsed">—</span> / <span id="aiQuotaTotal">—</span>
          <span class="used">used</span>
        </div>

        <button type="button" class="ai-create-bar" data-proto-click="showAiCreateModal()">
          <span class="acb-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
            </svg>
          </span>
          <span class="acb-text">
            <span class="acb-title">Create private topic</span>
            <span class="acb-description">Describe what you want - AI builds a private topic with read, listen, and watch modes.</span>
          </span>
          <span class="acb-arrow" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
          </span>
        </button>

        <div class="dmx-list-toolbar ai-create-toolbar dmx-mobile-filter-toolbar">
          <div class="dmx-toolbar-filters dmx-mobile-filter-toolbar__filters" id="aiFilterTabs">
            <button class="category-pill active" data-proto-click="filterAiCreate('completed', this)"><span class="dmx-filter-indicator" style="display:inline-block;width:6px;height:6px;border-radius:50%;background:var(--success);margin-right:6px;"></span>Completed</button>
            <button class="category-pill" data-proto-click="filterAiCreate('inprogress', this)"><span class="dmx-filter-indicator" style="display:inline-block;width:6px;height:6px;border-radius:50%;background:var(--info);margin-right:6px;"></span>In Progress</button>
          </div>
          <div class="dmx-toolbar-actions">
            <label class="dmx-toolbar-search" for="aiSearchInput">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg>
              <input type="search" inputmode="search" id="aiSearchInput" maxlength="120" autocomplete="off" placeholder="Search your topics...">
              <button type="button" id="aiSearchClear" class="dmx-search-clear" data-proto-click="clearAiSearch()" aria-label="Clear search" title="Clear" style="display:none;">×</button>
            </label>
            <button type="button" id="aiSearchBtn" class="dmx-search-button" data-proto-click="runAiSearch()">Search</button>
          </div>
        </div>
      </div>

      <!-- Course list lives outside the unlocked gate so it is
           always present in the DOM. The hydrator paints either
           the user's private courses (Pro / Max) or an empty
           state that points to the paywall (Free / Lite). Hiding
           it entirely made the view look broken for Free / Lite
           and broke the E2E sweep that waits for the list
           container to attach. -->
      <div class="ai-created-list" id="aiCreatedList" data-ai-courses-root>
        <div class="topic-card-compact-skeleton"></div>
        <div class="topic-card-compact-skeleton"></div>
        <div class="topic-card-compact-skeleton"></div>
      </div>
    </div>

    `;
